export const FILE_UPLOADING = 'zola/wedding/website/FILE_UPLOADING';
export const FILE_UPLOADED = 'zola/wedding/website/FILE_UPLOADED';
export const FILE_TEMP_UPLOADED = 'zola/wedding/website/FILE_TEMP_UPLOADED';
export const FILE_CROPPED = 'zola/wedding/website/FILE_CROPPED';
export const STORE_REFERENCE_KEY = 'zola/wedding/website/STORE_REFERENCE_KEY';
export const RESET_FILE_PREVIEW = 'zola/wedding/website/RESET_FILE_PREVIEW';
